import React from 'react'
import { useTranslation } from 'react-i18next'
import { useRequestContext } from '@cbgms/components/grid/Contexts/RequestContext'
import { IPaginatedRequest } from '@cbgms/api'
import { Fab } from '@mui/material'
import ExportDialogContent from './ExportDialogContent'
import ExportModal from './ExportModal'
import { Dialog, DialogTitleWithCloseButton } from '@carsys/ui'
import IosShareIcon from '@mui/icons-material/IosShare'

interface Template {
  Name: string
  UUID: string
}
interface ExportButtonProps {
  scope?: string
  gridColumns?: string[]
  loadAction: (params: IPaginatedRequest) => any
  wholesalerFormModal?: boolean | { templateList: Template[] }
  onDownload?: (selectedTemplate: string) => void
}

const ExportButton: React.FC<ExportButtonProps> = ({ scope, gridColumns, loadAction, wholesalerFormModal, onDownload }) => {
  const { t } = useTranslation()
  const { hasData } = useRequestContext()
  const [open, setOpen] = React.useState(false)

  const handleDialog = () => {
    setOpen(!open)
  }

  const isFabEnabled =
    wholesalerFormModal && typeof wholesalerFormModal === 'object'
      ? wholesalerFormModal.templateList && wholesalerFormModal.templateList.length > 0 && hasData
      : hasData

  return (
    <>
      <Fab
        title={t('Grid.ExportButtonText')}
        color='primary'
        size='small'
        data-testid='list-export-button'
        disabled={!isFabEnabled}
        onClick={handleDialog}
      >
        <IosShareIcon />
      </Fab>
      <Dialog aria-labelledby='customized-dialog-title' fullWidth maxWidth='xs' open={open}>
        <DialogTitleWithCloseButton onClose={handleDialog}>{t('Grid.ExportButtonText')}</DialogTitleWithCloseButton>
        {wholesalerFormModal ? (
          <ExportModal templateList={(wholesalerFormModal as { templateList: any[] }).templateList} onDownload={onDownload || (() => {})} />
        ) : (
          <ExportDialogContent scope={scope} gridColumns={gridColumns} loadAction={loadAction} />
        )}
      </Dialog>
    </>
  )
}

export default ExportButton
